import { render, staticRenderFns } from "./DistributionListPane.vue?vue&type=template&id=59b30eb0&scoped=true&"
import script from "./DistributionListPane.vue?vue&type=script&lang=js&"
export * from "./DistributionListPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b30eb0",
  null
  
)

export default component.exports